var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kst-input',{attrs:{"field":"Name","load-on-focus":"","data":_vm.userData,"catalog":_vm.Catalog}}),_c('kst-input',{attrs:{"field":"Comment","data":_vm.userData,"catalog":_vm.Catalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }